// @flow
import styled from "styled-components";
import { Th } from "../../components/TableX";

export const ThStat = styled(Th)`
	font-size: 10px;
	position: relative;
	cursor: pointer;
	user-select: none;

	.highlighter {
		display: none;

		&:before,
		&:after {
			position: absolute;
			left: 50%;
		}
	}

	&.active .highlighter{
		display: block;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #00ff9a;
		z-index: 1;
		
	}
	&.active{
		span{
			color: #003a31;
		}
	}

	&:hover {
		background: #00ff9a;
		color: #003a31;
	}

	.column-name {
		position: relative;
		z-index: 1;
	}

	svg {
		position: absolute;
		z-index: 1;
		left: 50%;
		margin-left: -.5em;
		fill: #003a31;

		&.top {
			top: 7px;
		}

		&.down {
			bottom: 7px;
		}
	}
`;

export default ThStat;


// WEBPACK FOOTER //
// ./src/components/ThStat/index.js